//#region src/utils/applicationMenu/applicationMenu.ts
var e = [];
function t() {
	let t = {}, n = {}, r = (e, t) => {
		let n = "before" in t ? t.before : void 0, r = "after" in t ? t.after : void 0;
		if (n) {
			let t = e.findIndex((e) => n.includes(e.key));
			if (t !== -1) return t;
		}
		if (r) {
			let t = e.findIndex((e) => r.includes(e.key));
			if (t !== -1) return t + 1;
		}
		return e.length;
	}, i = (e, t) => {
		let n = r(e, t);
		return [
			...e.slice(0, n),
			t,
			...e.slice(n)
		];
	}, a = (e, t) => {
		let n = "before" in e ? e.before : void 0, r = "after" in e ? e.after : void 0;
		return n?.includes(t) === !0 || r?.includes(t) === !0;
	}, o = (e, t) => e.reduce((e, n) => {
		if (n.key === t || !a(n, t)) return e;
		let r = e.filter((e) => e !== n);
		return i(r, n);
	}, e), s = (e, n) => {
		let r = t[e], i = r.indexOf(n);
		i !== -1 && (r.splice(i, 1), c(e));
	}, c = (e) => {
		n[e]?.forEach((e) => e());
	};
	return {
		getItems(n) {
			return t[n] ?? e;
		},
		subscribe(e, t) {
			let r = n[e] ??= /* @__PURE__ */ new Set();
			return r.add(t), () => r.delete(t);
		},
		register(e, n) {
			let r = t[e];
			return r ? t[e] = o(i(r, n), n.key) : t[e] = [n], c(e), () => s(e, n);
		}
	};
}
//#endregion
export { t as createApplicationMenu };
